/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/svenskdam/components/standalone/AuthorsList/theme';

export const AuthorsListTheme = theme;
